<template>
  <v-content class="content_body">
    <v-flex xs12>
      <h6 class="body-1 font-weight-bold lightblue--text">Resumo</h6>
      <v-layout row wrap>
        <v-flex xs2>
          <v-text-field
            label="Nº da Apólice"
            class="jns-input"
            :value="policy.id_apolice"
            disabled
          />
        </v-flex>
        <v-flex xs2>
          <v-text-field
            label="Nº do Endosso"
            class="jns-input"
            :value="policy.id_endosso"
            disabled
          />
        </v-flex>
        <v-flex xs3>
          <v-text-field
            label="Tomador"
            class="jns-input"
            :value="policy.tomador.nome"
            disabled
          />
        </v-flex>
        <v-flex xs3>
          <v-text-field
            label="Segurado"
            class="jns-input"
            :value="policy.segurado.nome"
            disabled
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3>
          <v-text-field
            label="Importância Segurada"
            class="jns-input"
            :value="valorImportanciaSegurada"
            disabled
          />
        </v-flex>
        <v-flex xs3>
          <v-text-field
            label="Inicio de Vigência (Atual)"
            class="jns-input"
            :value="inicioVigencia"
            disabled
          />
        </v-flex>
        <v-flex xs3>
          <v-text-field
            label="Final de Vigência (Atual)"
            class="jns-input"
            :value="fimVigencia"
            disabled
          />
        </v-flex>
      </v-layout>
    </v-flex>

    <hr />

    <importancia-segurada
      v-bind="[$attrs, $props]"
      v-on="$listeners"
      :model="importanciaSeguradaModel"
    />

    <hr />

    <vigencia
      v-bind="[$attrs, $props]"
      v-on="$listeners"
      :model="vigenciaModel"
    />

    <hr style="margin-bottom: 26px;" />

    <v-layout row wrap>
      <v-flex xs12 class="pb-0">
        <p class="label mb-0">Objeto</p>
      </v-flex>
      <v-flex xs3 v-for="(tag, index) in policy.objeto_tags" :key="index">
        <v-text-field
          class="jns-input"
          :label="tag.label"
          v-model="tag.value"
          placeholder=" "
          @keyup="changeTagPlaceholderContent(tag)"
          hide-details
          :rules="tagValidationRules"
        />
      </v-flex>
      <v-flex xs12>
        <v-card
          class="white-background"
          v-html="policy.objeto.replace(/(?:\r\n|\r|\n|\\r\\n)/g, '<br />')"
        />
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script lang="js">
import moment from "moment";
import { toMoneyString } from "@/libs/utils";
import ImportanciaSegurada from "./ImportanciaSegurada.vue";
import Vigencia from "./Vigencia.vue";
import { updatePlaceholderContent } from "@/libs/objectTags";

export default {
  name: "InformacoesDaApolice",
  step: {
    id: 0,
    number: "01",
    text: "Dados da Apólice",
    class: "proposta__container",
    step: "EndorsementForm"
  },
  props: {
    policy: Object,
    importanciaSeguradaModel: Object,
    vigenciaModel: Object
  },
  components: {
    ImportanciaSegurada,
    Vigencia
  },
  data() {
    return { toMoneyString };
  },
  computed: {
    inicioVigencia() {
      return moment(this.policy.inicio_vigencia).format("L");
    },
    fimVigencia() {
      return moment(this.policy.fim_vigencia).format("L");
    },
    valorImportanciaSegurada() {
      return toMoneyString(this.policy.valor_is);
    },
    tagValidationRules() {
      return [(v => Boolean(v) || "Campo obrigatório."),];
    }
  },
  methods: {
    changeTagPlaceholderContent(tag) {
      this.$emit("on-update-objeto-tag");
      updatePlaceholderContent(tag);
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss">
#jns {
  .content_body {
    padding: 20px 40px 77px 40px !important;
    background-color: white;
  }
}

p.label {
  color: #061d45;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/InformacoesDaApolice.vue